<template>
	<div class="modal fade" ref="modal" data-backdrop="static">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">
						Confirme os dados de ativação do contrato
					</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-8">
							<span>Razão social</span>
							<input
								type="text"
								v-model="razao_social"
								class="form-control"
							/>
							<br />
						</div>
						<div class="col-sm-4">
							<b>Código interno</b>
							<input
								type="text"
								v-model="cod_interno"
								class="form-control"
							/>
							<br />
						</div>

						<div class="col-sm-12">
							<b>Contato para ativação do contrato</b>
							<div class="input-group">
								<select v-model="contato" class="form-control">
									<option
										v-for="(cnt, id) in contatos"
										v-bind:key="id"
										:value="id"
									>
										{{ cnt.name }} &lt;{{ cnt.mail }}>
									</option>
								</select>
								<span class="input-group-btn">
									<button
										class="btn btn-success"
										@click="add_contato"
									>
										<i class="fa fa-plus"></i>
									</button>
								</span>
							</div>
						</div>
						<div
							v-if="contatos[contato] != undefined"
							class="col-sm-12"
						>
							<div class="well well-sm">
								<div class="row">
									<div class="col-sm-6">
										<b>Nome</b>
										<input
											type="text"
											v-model="contatos[contato].name"
											class="form-control"
										/>
									</div>
									<div class="col-sm-6">
										<b>Email</b>
										<input
											type="text"
											v-model="contatos[contato].mail"
											class="form-control"
										/>
									</div>
								</div>
							</div>
						</div>

						<div class="col-sm-12">
							<b>Modelo do contrato</b>

							<select
								v-model="templateSelecionado"
								class="form-control"
							>
								<option value="">Escolher</option>
								<option
									v-for="(item, index) in modelosDeDocumentos"
									:key="index"
									:value="item.cod"
								>
									{{ item.titulo }}
								</option>
							</select>

							<br />
						</div>
						<div class="col-sm-12">
							<label class="checkbox-inline">
								<input
									type="checkbox"
									v-model="saveClienteData"
								/>
								Salvar Informações de contato
							</label>
						</div>
						<div class="col-sm-12">
							<label class="checkbox-inline">
								<input
									type="checkbox"
									:disabled="!possoEnviar"
									v-model="sendMailActivation"
								/>
								Enviar email de ativação
							</label>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					.
					<button class="btn btn-delfaul pull-left" @click="closeMd">
						<i class="fa fa-close"></i>
						Cancelar
					</button>
					<button
						:disabled="!templateSelecionado"
						class="btn btn-warning"
						@click="SendContractc"
					>
						<i class="fa fa-save"></i>
						Gerar contrato
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import WBS from 'js/http';
	import isMail from 'js/isMail';
	console.log('mdAtivacao imported');
	export default {
		props: ['gestores'],
		data() {
			return {
				contato: 0,
				razao_social: '',
				saveClienteData: true,
				sendMailActivation: false,
				cod_interno: '',

				contatos: [],
				resolve: null,
				reject: null,
				possoEnviar: true,

				modelosDeDocumentos: [],
				templateSelecionado: '',
			};
		},
		computed: {
			watchMail() {
				if (this.contatos[this.contato] == undefined) return '';
				return this.contatos[this.contato].mail;
			},
		},
		watch: {
			watchMail: function (val) {
				if (isMail(val)) {
					this.possoEnviar = true;
				} else {
					this.sendMailActivation = false;
					this.possoEnviar = false;
				}
			},
		},

		methods: {
			add_contato() {
				this.contatos.push({ name: '', mail: '', tels: '' });
				this.contato = this.contatos.length - 1;
			},
			closeMd() {
				$(this.$refs.modal).modal('hide');
				this.reject();
			},
			// gerarContrato(){

			// },
			SendContractc() {
				const respostaASerEnviada = {
					contato: this.contato,
					contatos: this.contatos,
					razao_social: this.razao_social,
					saveClienteData: this.saveClienteData,
					sendMailActivation: this.sendMailActivation,
					codInterno: this.cod_interno,
					templateSelecionado: this.templateSelecionado,
				};
				// if(this.enviarContratoPorEmail && this.templateSelecionado != ""){
				//   respostaASerEnviada.linkDoContrato = this.gerarContrato()
				// }
				this.resolve(respostaASerEnviada);
				$(this.$refs.modal).modal('hide');
			},
			open(data) {
				WBS.send('public-custom-scnpj', { cnpj: data }, (resp) => {
					if (resp.status == 'success') {
						this.razao_social = resp.data.razao_social;
						this.contato = resp.data.contato;
						this.contatos = resp.data.contatos;

						if (isMail(this.contatos[this.contato].mail)) {
							this.sendMailActivation = true;
							this.possoEnviar = true;
						} else {
							this.sendMailActivation = false;
							this.possoEnviar = false;
						}

						$(this.$refs.modal).modal('show');
					} else {
						this.reject('E67: CNPJ Não localizado!');
					}
				});

				// this.name =
				// this.razao_social = data.cod_proposta.cnpj.razao_social

				// if(!Array.isArray(data.info)){
				//   // if()
				// }
				// if(data.cod_proposta.cnpj.contato != ""){
				//   this.mail = data.cod_proposta.cnpj.contato;
				// }

				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
			},
		},
		mounted() {
			console.log('mdAtivacao mounted');
			WBS.send('protected-read-gridTemplates', (resp) => {
				this.modelosDeDocumentos = resp.data.filter(
					(ItemModeloDeDocumento) => {
						if (
							ItemModeloDeDocumento.modalidade.indexOf(
								'CONTRATO'
							) != -1
						)
							return true;
					}
				);
			});
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/proposals/components/components/mdAtivacao.vue